import React, { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { ApolloError } from '@apollo/client';
import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProp {
  message?: string;
  error?: ApolloError;
}

const Error = ({
  message = '일시적인 오류로 결과를 표시할 수 없습니다.',
  error,
}: IProp) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className={cx('error')}>
      <div className={cx('inner')}>
        <p className={cx('text')}>{message}</p>
      </div>
    </div>
  );
};
export default Error;
